// extracted by css-extract-rspack-plugin
export default {"QueryEditorContainer":"e8ksO","isHidden":"tMbnp"};